import React, { } from 'react';
import {
  logoBlackTransparent,
} from "./images";
import { Link} from 'react-router-dom';

const Header = ({ setIsLoginOpen, isMobileMenuOpen, setIsMobileMenuOpen}) => {

  return (
    <header className="sticky top-0 z-20 bg-[#2b0062] text-white py-0 shadow-md">
      <nav className="container mx-auto px-4 flex items-center justify-between">
        <a href="/" className="flex items-center py-0 my-0">
          <img
            src={logoBlackTransparent}
            alt="LastCall"
            className={`h-24 w-auto object-contain invert`}
          />
        </a>

        {/* Hamburger Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden p-2 z-50"
          aria-label="Toggle menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Desktop Navbar */}
        <div className="hidden md:flex items-center space-x-12 text-2xl font-bold text-center">
          {/* {currentLocation.pathname !== "/about-us" && ( */}
            <Link to="/about-us" className="hover:opacity-80" onClick={() => window.scrollTo(0, 0)}>About Us</Link>
          {/* )} */}
          {/* {currentLocation.pathname !== "/faq" && ( */}
            <Link to="/faq" className="hover:opacity-80" onClick={() => window.scrollTo(0, 0)}>FAQ</Link>
          {/* )} */}
          <a href="https://calendar.app.google/64qw1CsuCwEXYG1v9" target="_blank" rel="noopener noreferrer" className="hover:opacity-80">Get a Demo</a>
          <Link to="/locations" className="hover:opacity-80" onClick={() => window.scrollTo(0, 0)}>Locations</Link>
          <button onClick={() => setIsLoginOpen(true)} className="hover:opacity-80">Log In</button>
        </div>

        {/* Mobile Navbar */}
        <div className={`fixed top-[10vh] left-0 w-full h-[90vh] bg-[#2b0062] text-white md:hidden transform transition-transform duration-500 ease-in-out origin-top 
          ${isMobileMenuOpen ? "translate-y-0" : "translate-y-[-100%]"}`}
          style={{ visibility: isMobileMenuOpen ? "visible" : "hidden", zIndex: 40 }}
        >
          <div className="flex flex-col items-center justify-start h-full gap-6 p-4">
            {/* {currentLocation.pathname !== "/about-us" && ( */}
              <Link to="/about-us" onClick={() => setIsMobileMenuOpen(false)} className="font-bold text-xl hover:bg-purple-100 px-6 py-3 w-3/4 text-center rounded-full transition-colors">
                About Us</Link>
            {/* )} */}
            {/* {currentLocation.pathname !== "/faq" && ( */}
              <Link to="/faq" onClick={() => setIsMobileMenuOpen(false)} className="font-bold text-xl hover:bg-purple-100 px-6 py-3 w-3/4 text-center rounded-full transition-colors">FAQ</Link>
            {/* )} */}
            <a href="https://calendar.app.google/64qw1CsuCwEXYG1v9" target="_blank" rel="noopener noreferrer" className="font-bold text-xl hover:bg-purple-100 px-6 py-3 w-3/4 text-center rounded-full transition-colors">Get a Demo</a>
            <Link to="/locations" onClick={() => setIsMobileMenuOpen(false)} className="font-bold text-xl hover:bg-purple-100 px-6 py-3 w-3/4 text-center rounded-full transition-colors">Locations</Link>
            <button onClick={() => { setIsMobileMenuOpen(false); setIsLoginOpen(true); }} className="font-bold text-xl hover:bg-purple-100 px-6 py-3 w-3/4 text-center rounded-full transition-colors">Log In</button>
            <a href="https://calendar.app.google/64qw1CsuCwEXYG1v9" target="_blank" rel="noopener noreferrer">
              <button className="border-2 border-white text-[#2b0062] bg-white px-14 py-2 rounded-full text-lg font-bold hover:bg-opacity-90 transition-colors">Try It</button>
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;


